import { FC } from "react";
import { Policy } from "@/types";
import { PolicyField } from "@/components/common/PolicyField";

interface PolicyFieldFromClaimantProps {
  policies?: Policy[];
}

/** @deprecated Use PolicyField from @/components/common/PolicyField directly */
export const PolicyFieldFromClaimant: FC<PolicyFieldFromClaimantProps> = ({ policies = [] }) => {
  return <PolicyField policies={policies} />;
};
